import styles from '../../css/form.module.css';
import React from 'react';

export const FieldWrapper = (props: { children: JSX.Element | JSX.Element[] }): JSX.Element => {
  return <div className={styles.fieldWrapper}>{props.children}</div>;
};
